import PillTextField from '@client/Applications/DataGrids/Components/PillTextField';
import { OptionTypeBase } from '@sprint/sprint-react-components';
import React from 'react';
import { ActionMeta, Options } from 'react-select';

interface Props {
    id: string;
    value: Options<OptionTypeBase> | undefined | null;
    onChange: (options: Options<OptionTypeBase>) => void;
    placeholder?: string;
    onSubmit?: () => void;
}

const JobTitlesPillTextFieldMultiple = React.forwardRef((props: Props, ref) => {
    const [inputValue, setInputValue] = React.useState('');

    const jobTitleLoadOptions = async (filter: string, _loadedOptions: any, { page }: any) => {
        // Return the current input as a selectable option
        if (filter.trim()) {
            return {
                options: [{ value: filter.trim(), label: filter.trim() }],
                hasMore: false,
                additional: { page: page + 1 },
            };
        }
        return { options: [], hasMore: false, additional: { page: page + 1 } };
    };

    const handleChange = (selected: Options<OptionTypeBase>, action: ActionMeta<any>) => {
        props.onChange(selected);
        // Clear input when a new pill is added
        if (action.action === 'select-option') {
            setInputValue('');
        }
    };

    const handleBlur = () => {
        // If user leaves the field with unpressed input and only 1 pill exists, add the input as a pill
        if (inputValue.trim() && Array.isArray(props.value)) {
            const newOption = { value: inputValue.trim(), label: inputValue.trim() };
            const exists = props.value.some((opt) => opt.label === inputValue.trim());
            if (!exists) {
                props.onChange([...props.value, newOption]);
                setInputValue('');
            }
        }
    };

    return (
        <PillTextField
            id={props.id}
            isMulti={true}
            placeholder={props.placeholder ?? 'Type job title and press Enter'}
            value={props.value}
            onChange={handleChange}
            onFilter={setInputValue}
            onBlur={handleBlur}
            controlledInputValue={inputValue}
            onSubmit={() => {
                if (props.onSubmit) props.onSubmit();
            }}
            loadOptions={jobTitleLoadOptions}
            isClearable={true}
            ref={ref}
        />
    );
});

export default JobTitlesPillTextFieldMultiple;
